export default __webpack_public_path__ + "static/media/introC.9a596e85.jpg";